import script from "./shop-v2.vue?vue&type=script&setup=true&lang=js"
export * from "./shop-v2.vue?vue&type=script&setup=true&lang=js"

import "./shop-v2.vue?vue&type=style&index=0&id=61fd856d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61fd856d"]])

export default __exports__